<template>
  <div class="services-page">
    <!-- Carousel Hero Section -->
    <section class="banner__two slider-two position-relative">
      <div class="pattern-layer">
        <div class="pattern-1 position-absolute" data-parallax='{"x": 100}' style="background-image: url('/shapes/shape-06.png')"></div>
      </div>
      <div class="image-layer position-absolute" style="background-image: url('/resource/page-title-bg.jpg')"></div>
      <div class="banner__data__two position-relative">
        <div class="banner-carousel owl-theme owl-carousel owl-dots-none">
          <div class="slide-item position-relative">
            <div class="container">
              <div class="row">
                <div class="col-lg-6 col-md-12">
                  <div class="content-box position-relative">
                    <div class="sub__title">
                      <h4 class="position-relative">
                        <span class="slider-text-anim two">Technology Services</span>
                      </h4>
                    </div>
                    <h2 class="position-relative">
                      <span class="slider-text-anim">Comprehensive </span><br />
                      <span class="slider-text-anim title__last">Technology <span>Solutions</span></span>
                    </h2>
                    <p>From custom software development to cloud infrastructure, we provide end-to-end technology services that drive innovation and business growth.</p>
                    <div class="btn-box">
                      <router-link to="/contact" class="theme-btn theme-btn-one">
                        <i class="icon-02"></i> Get Started
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="slide-item position-relative">
            <div class="container">
              <div class="row">
                <div class="col-lg-6 col-md-12">
                  <div class="content-box position-relative">
                    <div class="sub__title">
                      <h4 class="position-relative">
                        <span class="slider-text-anim two">Custom Development</span>
                      </h4>
                    </div>
                    <h2 class="position-relative">
                      <span class="slider-text-anim title__last">Tailored <span>Solutions</span> </span>
                    </h2>
                    <p>We build custom software solutions tailored to your specific business needs, from web applications to enterprise systems.</p>
                    <div class="btn-box">
                      <router-link to="/contact" class="theme-btn theme-btn-one">
                        <i class="icon-02"></i> Learn More
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="slide-item position-relative">
            <div class="container">
              <div class="row">
                <div class="col-lg-6 col-md-12">
                  <div class="content-box position-relative">
                    <div class="sub__title">
                      <h4 class="position-relative">
                        <span class="slider-text-anim two">Cloud & DevOps</span>
                      </h4>
                    </div>
                    <h2 class="position-relative">
                      <span class="slider-text-anim title__last">Scalable <span>Infrastructure</span></span>
                    </h2>
                    <p>Modern cloud infrastructure and DevOps practices to ensure your applications are scalable, reliable, and performant.</p>
                    <div class="btn-box">
                      <router-link to="/contact" class="theme-btn theme-btn-one">
                        <i class="icon-02"></i> Explore Services
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="banner__bottom">
          <div class="row">
            <div class="col-lg-6 col-md-12"></div>
            <div class="col-lg-6 col-md-12">
              <div class="banner__mission__block">
                <div class="mission__block">
                  <h3>Our Vision</h3>
                  <p>To be the leading provider of comprehensive technology services that transform businesses and drive digital innovation.</p>
                </div>
                <div class="mission__block">
                  <h3>Our Mission</h3>
                  <p>To deliver cutting-edge technology solutions that empower businesses to achieve their goals through innovative development and strategic consulting.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Intro Section -->
    <section class="services-intro position-relative see__pad">
      <div class="pattern-layer">
        <div class="pattern-1 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-2 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-3 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-4 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
      </div>
      
      <div class="header-container">
        <div class="row">
          <div class="col-lg-12">
            <div class="services-intro-content text-center">
              <div class="services-section-label">
                <h4>Technology Services</h4>
              </div>
              <div class="services-main-title">
                <h2>Technology Services We Offer</h2>
              </div>
              <div class="services-description">
                <p>Comprehensive technology solutions tailored to your business needs. From custom software development to cloud infrastructure, we provide end-to-end services that drive innovation and growth.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Service Categories Section -->
    <section class="service-categories position-relative see__pad">
      <div class="pattern-layer">
        <div class="pattern-5 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-6 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-7 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-8 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
      </div>

      <div class="header-container">
        <div class="row">
          <div class="col-lg-12">
            <div class="categories-header text-center">
              <div class="categories-section-label">
                <h4>Our Services</h4>
              </div>
              <div class="categories-main-title">
                <h2>Service Categories</h2>
              </div>
              <div class="categories-description">
                <p>Explore our comprehensive range of technology services designed to meet your business objectives and drive digital transformation.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="header-container">
        <div class="row">
          <div class="col-lg-4 col-md-6 mb-4">
            <div class="service-category-item">
              <div class="category-bg">
                <div class="block-shape-1"></div>
                <div class="block-shape-2"></div>
              </div>
              <div class="category-content">
                <div class="category-icon">
                  <i class="icon-01"></i>
                </div>
                <h3>Custom Software Development</h3>
                <p>Tailored software solutions built from scratch to meet your specific business requirements and objectives.</p>
                <ul>
                  <li>Web Applications</li>
                  <li>Mobile Applications</li>
                  <li>Desktop Software</li>
                  <li>Enterprise Solutions</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 mb-4">
            <div class="service-category-item">
              <div class="category-bg">
                <div class="block-shape-1"></div>
                <div class="block-shape-2"></div>
              </div>
              <div class="category-content">
                <div class="category-icon">
                  <i class="icon-02"></i>
                </div>
                <h3>Technology Consulting</h3>
                <p>Strategic technology guidance to help you make informed decisions and optimize your digital infrastructure.</p>
                <ul>
                  <li>Digital Strategy</li>
                  <li>Technology Assessment</li>
                  <li>Architecture Planning</li>
                  <li>Process Optimization</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 mb-4">
            <div class="service-category-item">
              <div class="category-bg">
                <div class="block-shape-1"></div>
                <div class="block-shape-2"></div>
              </div>
              <div class="category-content">
                <div class="category-icon">
                  <i class="icon-03"></i>
                </div>
                <h3>Cloud & DevOps</h3>
                <p>Scalable cloud infrastructure and automated deployment pipelines for modern application delivery.</p>
                <ul>
                  <li>Cloud Migration</li>
                  <li>Container Orchestration</li>
                  <li>CI/CD Pipelines</li>
                  <li>Infrastructure as Code</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 mb-4">
            <div class="service-category-item">
              <div class="category-bg">
                <div class="block-shape-1"></div>
                <div class="block-shape-2"></div>
              </div>
              <div class="category-content">
                <div class="category-icon">
                  <i class="icon-04"></i>
                </div>
                <h3>API & System Integration</h3>
                <p>Seamless integration of disparate systems and APIs to create unified, efficient workflows.</p>
                <ul>
                  <li>RESTful APIs</li>
                  <li>Microservices Architecture</li>
                  <li>Third-party Integrations</li>
                  <li>Data Synchronization</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 mb-4">
            <div class="service-category-item">
              <div class="category-bg">
                <div class="block-shape-1"></div>
                <div class="block-shape-2"></div>
              </div>
              <div class="category-content">
                <div class="category-icon">
                  <i class="icon-05"></i>
                </div>
                <h3>UI/UX & Prototyping</h3>
                <p>User-centered design solutions that create intuitive, engaging experiences for your customers.</p>
                <ul>
                  <li>User Research</li>
                  <li>Wireframing</li>
                  <li>Interactive Prototypes</li>
                  <li>Design Systems</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 mb-4">
            <div class="service-category-item">
              <div class="category-bg">
                <div class="block-shape-1"></div>
                <div class="block-shape-2"></div>
              </div>
              <div class="category-content">
                <div class="category-icon">
                  <i class="icon-01"></i>
                </div>
                <h3>Maintenance & Scaling</h3>
                <p>Ongoing support and optimization to ensure your systems remain reliable, secure, and performant.</p>
                <ul>
                  <li>Performance Monitoring</li>
                  <li>Security Updates</li>
                  <li>Scalability Planning</li>
                  <li>24/7 Support</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Engagement Models Section -->
    <section class="engagement-models position-relative see__pad">
      <div class="pattern-layer">
        <div class="pattern-9 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-10 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-11 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-12 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
      </div>
      
      <div class="header-container">
        <div class="row">
          <div class="col-lg-12">
            <div class="models-header text-center">
              <div class="models-section-label">
                <h4>Engagement Models</h4>
              </div>
              <div class="models-main-title">
                <h2>Flexible Engagement Models</h2>
              </div>
              <div class="models-description">
                <p>Choose the engagement model that best fits your project requirements, timeline, and budget constraints.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="header-container">
        <div class="row">
          <div class="col-lg-4 col-md-6 mb-4">
            <div class="engagement-model-item">
              <div class="model-bg">
                <div class="block-shape-1"></div>
                <div class="block-shape-2"></div>
              </div>
              <div class="model-content">
                <div class="model-icon">
                  <i class="icon-02"></i>
                </div>
                <h3>Fixed Cost</h3>
                <p>Perfect for well-defined projects with clear requirements and deliverables.</p>
                <div class="model-features">
                  <div class="feature-item">
                    <i class="icon-03"></i>
                    <span>Clear project scope</span>
                  </div>
                  <div class="feature-item">
                    <i class="icon-03"></i>
                    <span>Fixed timeline</span>
                  </div>
                  <div class="feature-item">
                    <i class="icon-03"></i>
                    <span>Predictable budget</span>
                  </div>
                  <div class="feature-item">
                    <i class="icon-03"></i>
                    <span>Milestone-based delivery</span>
                  </div>
                </div>
                <div class="model-price">
                  <span class="price-label">Starting from</span>
                  <span class="price-value">$5,000</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 mb-4">
            <div class="engagement-model-item">
              <div class="model-bg">
                <div class="block-shape-1"></div>
                <div class="block-shape-2"></div>
              </div>
              <div class="model-content">
                <div class="model-icon">
                  <i class="icon-04"></i>
                </div>
                <h3>Time & Materials</h3>
                <p>Ideal for projects with evolving requirements and flexible scope.</p>
                <div class="model-features">
                  <div class="feature-item">
                    <i class="icon-03"></i>
                    <span>Flexible scope</span>
                  </div>
                  <div class="feature-item">
                    <i class="icon-03"></i>
                    <span>Hourly billing</span>
                  </div>
                  <div class="feature-item">
                    <i class="icon-03"></i>
                    <span>Regular reporting</span>
                  </div>
                  <div class="feature-item">
                    <i class="icon-03"></i>
                    <span>Adaptive development</span>
                  </div>
                </div>
                <div class="model-price">
                  <span class="price-label">Starting from</span>
                  <span class="price-value">$75/hour</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 mb-4">
            <div class="engagement-model-item">
              <div class="model-bg">
                <div class="block-shape-1"></div>
                <div class="block-shape-2"></div>
              </div>
              <div class="model-content">
                <div class="model-icon">
                  <i class="icon-05"></i>
                </div>
                <h3>Dedicated Teams</h3>
                <p>Long-term partnerships with dedicated development teams for ongoing projects.</p>
                <div class="model-features">
                  <div class="feature-item">
                    <i class="icon-03"></i>
                    <span>Dedicated resources</span>
                  </div>
                  <div class="feature-item">
                    <i class="icon-03"></i>
                    <span>Monthly retainer</span>
                  </div>
                  <div class="feature-item">
                    <i class="icon-03"></i>
                    <span>Deep integration</span>
                  </div>
                  <div class="feature-item">
                    <i class="icon-03"></i>
                    <span>Scalable team size</span>
                  </div>
                </div>
                <div class="model-price">
                  <span class="price-label">Starting from</span>
                  <span class="price-value">$8,000/month</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Call to Action Section -->
    <section class="services-cta position-relative see__pad">
      <div class="pattern-layer">
        <div class="pattern-1 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-2 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-3 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
      </div>
      <div class="pattern-layer">
        <div class="pattern-4 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
      </div>
      
      <div class="header-container">
        <div class="row">
          <div class="col-lg-12">
            <div class="cta-content text-center">
              <div class="cta-title">
                <h2>Ready to Transform Your Business?</h2>
              </div>
              <div class="cta-description">
                <p>Let's discuss your project requirements and find the perfect technology solution for your business needs.</p>
              </div>
              <div class="cta-buttons">
                <router-link to="/contact" class="cta-btn primary-btn">
                  <i class="icon-02"></i> Get Started
                </router-link>
                <router-link to="/synergy" class="cta-btn secondary-btn">
                  <i class="icon-02"></i> View Our Products
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { onMounted } from 'vue'
import WOW from 'wowjs'

export default {
  name: 'ServicesPage',
  setup() {
    onMounted(async () => {
      // Initialize WOW.js
      new WOW.WOW({
        mobile: false
      }).init()

      // Import and initialize Owl Carousel
      try {
        await import('owl.carousel')
        
        // Initialize Owl Carousel for banner
        setTimeout(() => {
          if (window.$ && window.$.fn.owlCarousel) {
            window.$('.banner-carousel').owlCarousel({
              loop: true,
              margin: 0,
              nav: true,
              active: true,
              smartSpeed: 1000,
              autoplay: 6000,
              navText: ['<span class="icon-05"></span>', '<span class="icon-06"></span>'],
              responsive: {
                0: {
                  items: 1
                },
                600: {
                  items: 1
                },
                768: {
                  items: 1
                },
                992: {
                  items: 1
                },
                1200: {
                  items: 1
                }
              }
            })
          }
        }, 100)
      } catch (error) {
        console.error('Error loading Owl Carousel:', error)
      }
    })
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

/* Custom button styling for carousel - More specific to avoid conflicts */
.services-page .banner__two .btn-box .theme-btn {
  padding: 12px 30px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  text-transform: uppercase !important;
  letter-spacing: 1px !important;
  border-radius: 0 !important;
  background: linear-gradient(219deg, #FB0E76 0%, #910694 100%) !important;
  color: #fff !important;
  text-decoration: none !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 8px !important;
  transition: all 0.3s ease !important;
}

.services-page .banner__two .btn-box .theme-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 5px 15px rgba(251, 14, 118, 0.4) !important;
  color: #fff !important;
  text-decoration: none !important;
}

.services-page .banner__two .btn-box .theme-btn i {
  font-size: 12px !important;
  transition: transform 0.3s ease !important;
}

.services-page .banner__two .btn-box .theme-btn:hover i {
  transform: translateX(3px) !important;
}

/* Mission/Vision block styling */
.banner__mission__block {
  border-radius: 10px 0px 0px 0px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(15px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  margin-top: 20px;
}

.mission__block {
  padding: 40px 50px;
  border-right: 1px solid rgba(255, 255, 255, 0.10);
  flex: 1;
}

.mission__block:last-child {
  border-right: none;
}

.mission__block h3 {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
  font-family: 'Archivo', sans-serif;
}

.mission__block p {
  color: #ccc;
  font-size: 14px;
  line-height: 24px;
  margin: 0;
  font-family: 'Open Sans', sans-serif;
}

/* Reduce banner height - More specific to avoid conflicts */
.services-page section.banner__two {
  padding-top: 100px !important;
  padding-bottom: 100px !important;
}

.services-page .banner__two .content-box {
  padding-bottom: 60px !important;
}

/* Responsive adjustments - More specific to avoid conflicts */
@media (max-width: 768px) {
  .services-page .banner__two .content-box h2 {
    font-size: 50px !important;
    line-height: 60px !important;
  }
  
  .services-page .mission__block {
    padding: 30px 25px !important;
  }
  
  .services-page .mission__block h3 {
    font-size: 18px !important;
  }
  
  .services-page .mission__block p {
    font-size: 13px !important;
    line-height: 22px !important;
  }
}

/* Global Styles */
body {
  font-family: 'Open Sans', sans-serif;
  line-height: 1.6;
  color: #333;
}

.see__pad {
  padding: 100px 0;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Pattern Layers */
.pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.pattern-1 {
  top: 10%;
  right: 5%;
  width: 100px;
  height: 100px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-2 {
  bottom: 20%;
  left: 8%;
  width: 80px;
  height: 80px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-3 {
  top: 30%;
  left: 10%;
  width: 120px;
  height: 120px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-4 {
  top: 15%;
  right: 15%;
  width: 90px;
  height: 90px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-5 {
  bottom: 25%;
  right: 20%;
  width: 70px;
  height: 70px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-6 {
  top: 40%;
  left: 5%;
  width: 110px;
  height: 110px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.09;
}

.pattern-7 {
  bottom: 15%;
  left: 12%;
  width: 85px;
  height: 85px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-8 {
  top: 35%;
  right: 8%;
  width: 95px;
  height: 95px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-9 {
  top: 18%;
  left: 12%;
  width: 105px;
  height: 105px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.09;
}

.pattern-10 {
  bottom: 30%;
  right: 12%;
  width: 75px;
  height: 75px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-11 {
  top: 45%;
  left: 8%;
  width: 125px;
  height: 125px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-12 {
  bottom: 18%;
  right: 18%;
  width: 100px;
  height: 100px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.09;
}

/* Intro Section */
.services-intro {
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.services-intro-content {
  position: relative;
  z-index: 2;
}

.services-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #F6EC4F;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.services-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.services-description p {
  font-size: 18px;
  color: #fff;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.8;
}

/* Service Categories Section */
.service-categories {
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.categories-header {
  position: relative;
  z-index: 2;
  margin-bottom: 60px;
}

.categories-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #F6EC4F;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.categories-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.categories-description p {
  font-size: 18px;
  color: #fff;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.8;
}

.service-category-item {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.1);
  border-radius: 15px;
  padding: 40px 30px;
  height: 100%;
  position: relative;
  transition: all 0.3s ease;
  overflow: hidden;
}

.service-category-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 50px rgba(246, 236, 79, 0.2);
  border-color: #F6EC4F;
}

.category-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.block-shape-1 {
  position: absolute;
  top: -20px;
  right: -20px;
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, rgba(246, 236, 79, 0.1), rgba(246, 236, 79, 0.05));
  border-radius: 50%;
  opacity: 0.3;
}

.block-shape-2 {
  position: absolute;
  bottom: -30px;
  left: -30px;
  width: 80px;
  height: 80px;
  background: linear-gradient(45deg, rgba(246, 236, 79, 0.08), rgba(246, 236, 79, 0.03));
  border-radius: 50%;
  opacity: 0.4;
}

.category-content {
  position: relative;
  z-index: 2;
}

.category-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #F6EC4F, #E6D43A);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
}

.category-icon i {
  font-size: 24px;
  color: #00061A;
}

.category-content h3 {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 15px;
  font-family: 'Archivo', sans-serif;
}

.category-content p {
  font-size: 16px;
  color: #fff;
  margin-bottom: 20px;
  line-height: 1.6;
}

.category-content ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.category-content ul li {
  color: #fff;
  font-size: 14px;
  margin-bottom: 8px;
  padding-left: 20px;
  position: relative;
}

.category-content ul li:before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #F6EC4F;
  font-weight: bold;
}

/* Engagement Models Section */
.engagement-models {
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.models-header {
  position: relative;
  z-index: 2;
  margin-bottom: 60px;
}

.models-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #F6EC4F;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.models-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.models-description p {
  font-size: 18px;
  color: #fff;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.8;
}

.engagement-model-item {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.1);
  border-radius: 15px;
  padding: 40px 30px;
  height: 100%;
  position: relative;
  transition: all 0.3s ease;
  overflow: hidden;
}

.engagement-model-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 50px rgba(246, 236, 79, 0.2);
  border-color: #F6EC4F;
}

.model-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.model-content {
  position: relative;
  z-index: 2;
}

.model-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #F6EC4F, #E6D43A);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
}

.model-icon i {
  font-size: 24px;
  color: #00061A;
}

.model-content h3 {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 15px;
  font-family: 'Archivo', sans-serif;
}

.model-content p {
  font-size: 16px;
  color: #fff;
  margin-bottom: 25px;
  line-height: 1.6;
}

.model-features {
  margin-bottom: 30px;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.feature-item i {
  color: #F6EC4F;
  margin-right: 10px;
  font-size: 14px;
}

.feature-item span {
  color: #fff;
  font-size: 14px;
}

.model-price {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid rgba(246, 236, 79, 0.2);
}

.price-label {
  display: block;
  color: #fff;
  font-size: 14px;
  margin-bottom: 5px;
}

.price-value {
  display: block;
  color: #F6EC4F;
  font-size: 24px;
  font-weight: 700;
  font-family: 'Archivo', sans-serif;
}

/* Call to Action Section */
.services-cta {
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.cta-content {
  position: relative;
  z-index: 2;
}

.cta-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.cta-description p {
  font-size: 18px;
  color: #fff;
  max-width: 600px;
  margin: 0 auto 40px;
  line-height: 1.8;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 15px 30px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.primary-btn {
  background: linear-gradient(135deg, #F6EC4F, #E6D43A);
  color: #00061A;
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(246, 236, 79, 0.3);
}

.secondary-btn {
  background: transparent;
  color: #F6EC4F;
  border-color: #F6EC4F;
}

.secondary-btn:hover {
  background: #F6EC4F;
  color: #00061A;
  transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 767px) {
  .services-main-title h2,
  .categories-main-title h2,
  .models-main-title h2,
  .cta-title h2 {
    font-size: 36px;
    line-height: 46px;
  }
  
  .services-section-label h4,
  .categories-section-label h4,
  .models-section-label h4 {
    letter-spacing: 8px;
    font-size: 16px;
  }
  
  .service-category-item,
  .engagement-model-item {
    padding: 30px 20px;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .cta-btn {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }
}

@media (max-width: 399px) {
  .see__pad {
    padding: 60px 0;
  }
  
  .services-main-title h2,
  .categories-main-title h2,
  .models-main-title h2,
  .cta-title h2 {
    font-size: 28px;
    line-height: 38px;
  }
}
</style>
